<template>
  <vx-card class="mt-base mb-5" :title="activityTitle">
    <p class="mb-5" style="color: #da2c2c">
      Please consult with your medical practitioner before attempting these physical activities.<br />
      You can download/print the physical activities
      <a
        aria-label="Download the physical activities"
        :href="'content/policing/physical_tasks_medical_check.pdf' | blob_url"
        target="_blank"
        >here</a
      >
      to show your medical practitioner.
    </p>
    <p class="mb-5">
      The physical skills you require to pass the entrance exam will be the same skills you’ll need
      to perform your duties well as a police officer.
    </p>
    <p class="mb-5">
      In this activity, you’ll get a chance to work on some of these skills and a chance to improve
      them.
    </p>
    <p class="mb-5">
      First, let’s take a look at the Police Fitness Test from Victoria Police. While the exact
      details of the physical fitness requirements will change from force to force (state to state),
      the following will give you a good idea of what you can expect.
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <custom-video
          aria-label="Watch Policing Activity 1: Check Your Physical Fitness video"
          elem-id="video-btn-0"
          :video-image="videoTrigger1"
          :video-url="videos[1]"
        />
      </div>
    </div>
    <p class="mb-5">
      Here’s a breakdown of the different aspects of the Victoria Police Fitness Test:
    </p>
    <ul class="default-list">
      <li>Illinois Agility Test - Complete in under 20 seconds</li>
      <li>Grip Test 30kg+</li>
      <li>5 Push-ups</li>
      <li>Go over a 1.3m obstacle</li>
      <li>60 seconds prone hold</li>
      <li>Beep Test - Reach level 5.01</li>
      <li>100m swim in under 4 minutes</li>
    </ul>
    <p class="mb-5">
      In the following physical skills tasks, you’ll get an opportunity to practice 3 of these that
      require no special equipment:
    </p>
    <ul class="default-list">
      <li>Push-ups</li>
      <li>The Prone Bridge</li>
      <li>The Illinois Agility Test</li>
    </ul>

    <h4 class="mb-5"><u>Your Task:</u></h4>
    <p class="mb-5">
      1. Click on each of the tiles below (one after the other) and look at the information on Push
      Ups, the Prone Bridge and the Illinois Agility Test.
    </p>
    <p class="mb-5">
      2. Download the “Physical Training Record Sheet” (link below) and complete this for 6 days
    </p>
    <p class="mb-5">
      3. Once you have completed this, upload your completed sheet using the upload section at the
      bottom of the page
    </p>

    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12" class="my-5">
      <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
        <router-link to="/student/work-experience-info/policing/check-your-physical-fitness-1"
          ><img
            src="@/assets/images/experiences/policing/push_up_button.jpg"
            class="img-responsive px-5"
            alt="1. Push ups: read info and watch video"
        /></router-link>
      </vs-col>
      <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
        <router-link to="/student/work-experience-info/policing/check-your-physical-fitness-2"
          ><img
            src="@/assets/images/experiences/policing/prone_bridge_button.jpg"
            class="img-responsive px-5"
            alt="2. Prone bridge: read info and watch video"
        /></router-link>
      </vs-col>
      <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
        <router-link to="/student/work-experience-info/policing/check-your-physical-fitness-3"
          ><img
            src="@/assets/images/experiences/policing/agility_test_button.jpg"
            class="img-responsive px-5"
            alt="3. Illinois Agility Test: read info and watch video"
        /></router-link>
      </vs-col>
    </vs-row>

    <label>Download Physical Training Record Sheet</label>
    <div class="overflow-hidden">
      <a
        :href="'content/policing/pt_record_sheet.pdf' | blob_url"
        target="_blank"
        class="inline btn btn-secondary btn-size-medium includedIcon mt-5 mr-5 float-left"
      >
        <download-icon />Download PT Record Sheet
      </a>
      <a
        :href="'content/policing/physical_tasks_medical_check.pdf' | blob_url"
        target="_blank"
        class="inline btn btn-secondary btn-size-medium includedIcon mt-5 mr-5 float-left"
      >
        <download-icon />PT Sheet Instructions
      </a>
    </div>

    <vs-divider />

    <p>Upload Physical Training Record Sheet:</p>
    <br />
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      filetype="pdf"
      index="1"
    />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import { DownloadIcon } from 'vue-feather-icons';
import CustomVideo from '@/components/CustomVideo.vue';

export default {
  components: {
    CustomVideo,
    DownloadIcon,
  },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/policing/vic_police_fitness_test.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/F9casmTr1dE',
      },
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
